<template>
  <v-app id="desempenho-por-equipe" class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-data-table
          @pagination="getPagination"
          :disable-pagination="true"
          hide-default-footer
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          item-key="index"
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items"> </template>

          <template v-slot:item.ordem="{ index }">
            {{ index + 1 + 'º' }}
          </template>

          <template
            v-for="(indicador, index) in items"
            v-slot:[`item.${indicador.slot}`]="{ item }"
          >
            <td
              :key="index"
              v-bind:class="
                indicadorColor(item[`${indicador.slot}`], `${indicador.slot}`)
              "
              class="font-weight-bold text-center"
            >
              {{ item[`${indicador.slot}`] }}
            </td>
          </template>

          <template
            v-for="(item, index) in items"
            v-slot:[`header.${item.slot}`]="{ header }"
          >
            {{ header.text }}
            <span
              :key="index"
              v-b-tooltip.hover.right
              :title="item.text"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaCadastros',
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      items: [
        {
          slot: 'pn_6_consultas_resultado',
          text: 'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a primeira até a 12ª semana de gestação.',
        },
        {
          slot: 'pn_hiv_sifilis_resultado',
          text: 'Proporção de gestantes com realização de exames para sífilis e HIV.',
        },
        {
          slot: 'pn_odontologia_resultado',
          text: 'Proporção de gestantes com atendimento odontológico realizado.',
        },

        {
          slot: 'citopatologico_resultado',
          text: 'Cobertura de exame citopatológico.',
        },
        {
          slot: 'crianca_polio_penta_resultado',
          text: 'Cobertura vacinal de Poliomielite inativada e da Pentavalente.',
        },
        {
          slot: 'pa_hipertensao_resultado',
          text: 'Percentual de pessoas hipertensas com Pressão Arterial aferida em cada semestre.',
        },
        {
          slot: 'hg_diabetes_resultado',
          text: 'Percentual de diabéticos com solicitação de hemoglobina glicada.',
        },
        {
          slot: 'desempenho',
          text: 'O desempenho é calculado pela média dos resultados individuais dos indicadores e ponderada pelos pesos de cada indicador multiplicada pelo ISF.',
        },
      ],
      currentPage: 1,
      enabled: null,
      headers: [
        {
          text: 'ORDEM',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'ordem',
        },
        {
          text: 'NOME DA EQUIPE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'no_equipe',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'nu_ine',
        },
        {
          text: 'I1',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'pn_6_consultas_resultado',
        },
        {
          text: 'I2',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'pn_hiv_sifilis_resultado',
        },
        {
          text: 'I3',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'pn_odontologia_resultado',
        },
        {
          text: 'I4',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'citopatologico_resultado',
        },
        {
          text: 'I5',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'crianca_polio_penta_resultado',
        },
        {
          text: 'I6',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'pa_hipertensao_resultado',
        },
        {
          text: 'I7',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'hg_diabetes_resultado',
        },
        {
          text: 'ISFE',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'isfe',
        },
        {
          text: 'DESEMPENHO',
          align: 'center',
          filterable: false,
          sortable: false,
          value: 'desempenho',
        },
        {
          text: 'PERÍODO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'quadrimestre',
        },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        index: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    indicadorColor(percentual, indicador) {
      switch (indicador) {
        case 'pn_6_consultas_resultado':
          if (percentual < 45) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'pn_hiv_sifilis_resultado':
          if (percentual < 60) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'pn_odontologia_resultado':
          if (percentual < 60) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'citopatologico_resultado':
          if (percentual < 40) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'crianca_polio_penta_resultado':
          if (percentual < 95) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'pa_hipertensao_resultado':
          if (percentual < 50) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'hg_diabetes_resultado':
          if (percentual < 50) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss">
#desempenho-por-equipe .cpf-cns {
  margin-bottom: 0px;
}
#desempenho-por-equipe .td-interna {
  border-bottom: unset;
  padding: 0 16px;
  gap: 5px;
  margin: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0px;
  gap: 20px;
  span {
    width: 195px;
    display: flex;
  }
  .div-td-interna {
    display: flex;
    /*   min-width: 67px; */
    gap: 5px;
  }

  @media screen and (max-width: 600px) {
    display: flex;
    align-items: center;
  }
  span {
    font-weight: bold;
    color: #00000099;
    font-size: 16px;
  }
}
</style>

<style>
#desempenho-por-equipe .v-data-table .v-data-table-header tr th {
  font-size: 13px !important;
}
</style>
